module.exports = __webpack_public_path__ + "img/3.f84e635a.png";